import { INPUT_TYPES } from '../utils/constants';
export default {
  title: 'Title Description Spacing',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.allowTitle && styleParams.allowDescription;
  },
  type: INPUT_TYPES.NUMBER,
  "default": 6,
  min: 0,
  max: 50,
  description: "Set the spacing between the title and the description.\n  "
};